export const STORE_DATA: string = 'DATA';
export const STORE_LOCALE: string = 'LOCALE';